// Journey master data now comes from Laravel (see services/journeyService.js
// and JourneysList.js/JourneyDetail.js). JOURNEYS/getJourney below are kept
// ONLY as a genuine-API-failure fallback for those two screens — never used
// when Laravel responds successfully, including with an empty list. Real
// per-shop `visited` progress still isn't tracked server-side, so
// getCurrentJourney/getCompletedJourneys (mock-only helpers) are no longer
// wired into My Profile's production path.

function CafeIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M5 9h11v5a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4V9Z" stroke="#8a5a2b" strokeWidth="2" strokeLinejoin="round" />
      <path d="M16 10h2.2a2.3 2.3 0 0 1 0 4.6H16" stroke="#8a5a2b" strokeWidth="2" strokeLinecap="round" />
      <path d="M8 3.5c-.6 1 .6 1.8 0 2.8M11.5 3.5c-.6 1 .6 1.8 0 2.8" stroke="#8a5a2b" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

function BagIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M6 8h12l-1 12H7L6 8Z" stroke="#c96a12" strokeWidth="2" strokeLinejoin="round" />
      <path d="M9 8V6a3 3 0 0 1 6 0v2" stroke="#c96a12" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

function BurgerIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M4 10c0-3 3.6-5 8-5s8 2 8 5H4Z" stroke="#d1482e" strokeWidth="2" strokeLinejoin="round" />
      <path d="M3.5 12.5h17M4 15h16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z" stroke="#d1482e" strokeWidth="2" strokeLinejoin="round" />
    </svg>
  );
}

function BookIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M4 5.5C6 4.5 9 4.5 11 5.5v13c-2-1-5-1-7 0v-13Z" stroke="#3d5bd0" strokeWidth="2" strokeLinejoin="round" />
      <path d="M20 5.5c-2-1-5-1-7 0v13c2-1 5-1 7 0v-13Z" stroke="#3d5bd0" strokeWidth="2" strokeLinejoin="round" />
    </svg>
  );
}

function GameIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M6 9h12l1.6 6.2a2 2 0 0 1-2.9 2.2L14 15h-4l-2.7 2.4a2 2 0 0 1-2.9-2.2L6 9Z" stroke="#3d4470" strokeWidth="2" strokeLinejoin="round" />
      <path d="M8.5 11v3M7 12.5h3" stroke="#3d4470" strokeWidth="1.8" strokeLinecap="round" />
      <circle cx="16" cy="11.5" r="0.9" fill="#3d4470" />
      <circle cx="17.6" cy="13" r="0.9" fill="#3d4470" />
    </svg>
  );
}

function IceCreamIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M8 10a4 4 0 0 1 8 0c0 .5-1.8 1-4 1s-4-.5-4-1Z" stroke="#d6427e" strokeWidth="2" strokeLinejoin="round" />
      <path d="M9 11l2.4 9.2a.7.7 0 0 0 1.2 0L15 11" stroke="#d6427e" strokeWidth="2" strokeLinejoin="round" />
    </svg>
  );
}

function CartIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M4 5h2l1.6 9.6a2 2 0 0 0 2 1.7h6.9a2 2 0 0 0 2-1.6L19.5 8.5H7.3" stroke="#c96a12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="10" cy="19.5" r="1.3" fill="#c96a12" />
      <circle cx="16.5" cy="19.5" r="1.3" fill="#c96a12" />
    </svg>
  );
}

function ElectronicsIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <rect x="3.5" y="6" width="17" height="11" rx="1.8" stroke="#4a4a55" strokeWidth="2" />
      <circle cx="12" cy="11.5" r="2.6" stroke="#4a4a55" strokeWidth="1.8" />
      <path d="M9 19h6" stroke="#4a4a55" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

function ShirtIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M8 4 4 7l2 3 2-1.3V20h8V8.7L18 10l2-3-4-3-2 2h-4L8 4Z" stroke="#d6427e" strokeWidth="2" strokeLinejoin="round" />
    </svg>
  );
}

export const CATEGORY_STYLES = {
  cafe: { bg: '#f3e6d8', icon: <CafeIcon /> },
  fashion: { bg: '#fde3cf', icon: <BagIcon /> },
  food: { bg: '#fbe0dc', icon: <BurgerIcon /> },
  books: { bg: '#e3e8fd', icon: <BookIcon /> },
  gaming: { bg: '#e4e6ee', icon: <GameIcon /> },
  icecream: { bg: '#fde0ea', icon: <IceCreamIcon /> },
  supermarket: { bg: '#fde9cf', icon: <CartIcon /> },
  electronics: { bg: '#e6e6e9', icon: <ElectronicsIcon /> },
  shirt: { bg: '#fbe0ea', icon: <ShirtIcon /> },
};

export const JOURNEYS = [
  {
    id: 1,
    title: 'Journey 2',
    subtitle: 'Explore amazing shops and collect rewards',
    theme: 'mountain',
    shops: [
      { id: 1, name: 'Brew & Co.', category: 'Café', style: 'cafe', visited: true },
      { id: 2, name: 'Style Hub', category: 'Fashion', style: 'fashion', visited: true },
      { id: 3, name: 'Burger Point', category: 'Food & Drinks', style: 'food', visited: false },
      { id: 4, name: 'Book Nest', category: 'Books & Stationery', style: 'books', visited: false },
      { id: 5, name: 'Game Zone', category: 'Gaming', style: 'gaming', visited: false },
    ],
  },
  {
    id: 2,
    title: 'Journey 3',
    subtitle: 'Discover new places and more rewards',
    theme: 'beach',
    shops: [
      { id: 1, name: 'Sweet Scoop', category: 'Ice Cream', style: 'icecream', visited: true },
      { id: 2, name: 'Fresh Mart', category: 'Supermarket', style: 'supermarket', visited: false },
      { id: 3, name: 'Tech World', category: 'Electronics', style: 'electronics', visited: false },
      { id: 4, name: 'Trendz', category: 'Fashion', style: 'shirt', visited: false },
    ],
  },
  {
    id: 3,
    title: 'Journey 1',
    subtitle: 'Your first completed adventure with Zini',
    theme: 'beach',
    shops: [
      { id: 1, name: 'Daily Grind', category: 'Café', style: 'cafe', visited: true },
      { id: 2, name: 'Trend Closet', category: 'Fashion', style: 'fashion', visited: true },
      { id: 3, name: 'Snap Studio', category: 'Electronics', style: 'electronics', visited: true },
    ],
  },
];

export function journeyStats(journey) {
  const total = journey.shops.length;
  const visited = journey.shops.filter((shop) => shop.visited).length;
  const pct = total ? Math.round((visited / total) * 100) : 0;
  return { total, visited, pct };
}

export function getJourney(id) {
  return JOURNEYS.find((journey) => journey.id === id) || JOURNEYS[0];
}

// The single journey still in progress — the first one that isn't fully
// visited yet. Journeys are meant to be worked through one at a time, so
// only this one shows as "current" on the Profile page.
export function getCurrentJourney(journeys = JOURNEYS) {
  return journeys.find((journey) => journeyStats(journey).pct < 100) || null;
}

// Journeys where every shop has been visited.
export function getCompletedJourneys(journeys = JOURNEYS) {
  return journeys.filter((journey) => journeyStats(journey).pct === 100);
}
